import styled, { css } from 'styled-components';
import HBText from '../HBText/HBText';
import { vars } from '../../theme';

export const ContextualContainer = styled.div<{
    horizontalOffset: number;
    verticalOffset: number;
    width?: number;
    $backgroundColor: string;
}>`
    ${({ $backgroundColor }) =>
        css`
            background-color: ${$backgroundColor};
            + .__floater__arrow svg * {
                fill: ${$backgroundColor};
            }
        `};
    width: 240px;
    border-radius: ${vars.radius.xs};
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 20px;
    ${({ horizontalOffset }) =>
        horizontalOffset != null &&
        css`
            margin-left: ${horizontalOffset}px;
        `}
    ${({ verticalOffset }) =>
        verticalOffset != null &&
        css`
            margin-top: ${verticalOffset}px;
        `}
    ${({ width }) =>
        width != null &&
        css`
            width: ${width}px;
        `}
`;

export const ContextualDescription = styled(HBText)`
    white-space: pre-line;
`;

export const ContextualContentWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const ContextualTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
